export default "__VITE_ASSET__BvZrHw66__"